import Fetch from '@/api';

const state = {
  showDrugCode: false,
  importFileUrl: ''
};

const mutations = {
  SET_SHOW_DRUG_CODE(state, data) {
    state.showDrugCode = data;
  },
  SET_IMPORT_FILE_URL(state, data) {
    state.importFileUrl = data;
  }
};

const actions = {
  FetchDrugSetting({ commit }, params) {
    Fetch.drug_setting().then(res => {
      commit('SET_SHOW_DRUG_CODE', res.showDrugCode);
      commit('SET_IMPORT_FILE_URL', res.importFileUrl);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
